import React, { Suspense, lazy } from 'react'
import ToastContainers from './Utils/ToastContainer'
import PageNotFound404 from './Errors/PageNotFound404'
import { BrowserRouter, Route, Routes } from 'react-router-dom'
import ThemeRefresh from './Utils/ThemeRefresh'
import ScrollToTop from './Utils/ScrollToTop'
import ProfileBootstrap from './Components/ProfileBootstrap'
import Base from './Pages/Base'
import './App.css'

const Home = lazy(() => import('./Pages/Home'))
const Ingradients = lazy(() => import('./Pages/Ingradients'))
const Shop = lazy(() => import('./Pages/Shop'))
const Cart = lazy(() => import('./Pages/Cart'))
const Checkout = lazy(() => import('./Pages/Checkout'))
const OrderSuccess = lazy(() => import('./Pages/OrderSuccess'))
const LeaveReview = lazy(() => import('./Pages/LeaveReview'))
const AuthFlow = lazy(() => import('./Pages/AuthFlow'))
const ForgotPassword = lazy(() => import('./Pages/ForgotPassword'))
const ResetPassword = lazy(() => import('./Pages/ResetPassword'))
const Dashboard = lazy(() => import('./Pages/Dashboard'))
const Contact = lazy(() => import('./Pages/Contact'))
const Payment = lazy(() => import('./Pages/Payment'))
const PaymentResult = lazy(() => import('./Pages/PaymentResult'))
const TamaraResult = lazy(() => import('./Pages/TamaraResult'))
const AboutSlimfast = lazy(() => import('./Pages/AboutSlimfast'))
const ProductDetail = lazy(() => import('./Pages/ProductDetail'))
const CampaignLanding = lazy(() => import('./Pages/CampaignLanding'))

function PageLoader() {
  return (
    <div style={{ minHeight: '40vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <span className="n900-clr">Loading…</span>
    </div>
  )
}

function App() {
  return (
    <>
      <BrowserRouter>
        <ScrollToTop />
        <ThemeRefresh />
        <ProfileBootstrap />
        <ToastContainers />

        <Suspense fallback={<PageLoader />}>
          <Routes>
            <Route path='/' element={<Base><Home /></Base>} />
            <Route path='/ingredients' element={<Base><Ingradients /></Base>} />
            <Route path='/shop' element={<Base><Shop /></Base>} />
            <Route path='/about' element={<Base><AboutSlimfast /></Base>} />
            <Route path='/product/:slug' element={<Base><ProductDetail /></Base>} />
            <Route path='/cart' element={<Base><Cart /></Base>} />
            <Route path='/checkout' element={<Base><Checkout /></Base>} />
            <Route path='/order-success' element={<Base><OrderSuccess /></Base>} />
            <Route path='/leave-review' element={<Base><LeaveReview /></Base>} />
            <Route path='/sign-in' element={<AuthFlow />} />
            <Route path='/sign-up' element={<AuthFlow />} />
            <Route path='/forgot-password' element={<ForgotPassword />} />
            <Route path='/reset-password' element={<ResetPassword />} />
            <Route path='/dashboard' element={<Base><Dashboard /></Base>} />
            <Route path='/contact' element={<Base><Contact /></Base>} />
            <Route path='/payment' element={<Base><Payment /></Base>} />
            <Route path='/payment-result' element={<Base><PaymentResult /></Base>} />
            <Route path='/tamara-result' element={<Base><TamaraResult /></Base>} />
            <Route path='/campaign' element={<CampaignLanding />} />
            <Route path='*' element={<PageNotFound404 />} />
          </Routes>
        </Suspense>
      </BrowserRouter>
    </>
  )
}

export default App
